import { ApiGeoUnit } from '@ibe/api';

export enum TypeCodeKey {
  PSEUDO = 'PSEUDO',
  AP = 'AP'
}

export enum PSEUDO_CODE {
  ALL = 'ALL',
  DE_ALL = 'DE_ALL',
  DE_NORTH = 'DE_NORTH',
  DE_SOUTH = 'DE_SOUTH',
  DE_EAST = 'DE_EAST',
  DE_WEST = 'DE_WEST'
}

export const usePseudoGeoOption = ({
  options,
  selectedOptions,
  setSelectedOptions,
  onOptionClick
}: {
  options: ApiGeoUnit[];
  selectedOptions: ApiGeoUnit[];
  setSelectedOptions: (option: ApiGeoUnit[]) => void;
  onOptionClick: (a: ApiGeoUnit) => void;
}) => {
  const allOptionsSelected = getAllOptions(options).length === selectedOptions.length;

  const onPseudoGeoOptionClick = (option: ApiGeoUnit): void => {
    const isPseudo = option.typeCode === TypeCodeKey.PSEUDO;
    if (isPseudo) {
      if (option.code === PSEUDO_CODE.ALL) {
        return setSelectedOptions(allOptionsSelected ? [] : [...getAllOptions(options)]);
      }

      const geoUnitChildren = Object.keys(option.children).map(key => option.children[key]);
      const flattedGeoUnitChildren = geoUnitChildren.flatMap(itm => itm.code);
      const areAllChildrenChecked =
        selectedOptions.filter(selectedOption =>
          flattedGeoUnitChildren.includes(selectedOption.code)
        ).length === flattedGeoUnitChildren.length;

      let newSelectedOptions = [...selectedOptions];
      newSelectedOptions = [
        ...newSelectedOptions.filter(
          selectedOption => !flattedGeoUnitChildren.includes(selectedOption?.code)
        )
      ];
      if (!areAllChildrenChecked) newSelectedOptions = [...newSelectedOptions, ...geoUnitChildren];
      return setSelectedOptions(newSelectedOptions);
    }
    return onOptionClick(option);
  };

  return {
    onPseudoGeoOptionClick,
    allOptionsSelected
  };
};

export const getAllOptions = (options: ApiGeoUnit[]): ApiGeoUnit[] => {
  let allOptions: ApiGeoUnit[] = [];
  options.map(opt => {
    allOptions = allOptions.concat(Object.keys(opt.children).map(child => opt.children[child]));
  });
  return allOptions;
};
